import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage, Invoice } from 'types';
import { client } from 'utils/api-client';

export default function useVoidInvoice(): UseMutationResult<
  AxiosResponse<Invoice>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const voidInvoice = (invoiceId: string): Promise<AxiosResponse<Invoice>> => {
    return client.post(`invoices/${invoiceId}/void/`);
  };

  return useMutation(voidInvoice, {
    onSuccess: () => {
      queryClient.invalidateQueries('invoices');
      queryClient.invalidateQueries('upcoming-revenue');
      queryClient.invalidateQueries('past-due-payments');
    },
  });
}
